import React, { forwardRef } from 'react';
import ReusableButton from '../ReusableButton/ReusableButton.js';
import './CollapseTextButton.css';

/**
 * CollapseTextButton
 * - Uses the same base styles/props as ReusableButton (pill when `shape="pill"`).
 * - Shows icon only by default.
 * - Reveals text on hover/focus-visible.
 */
const CollapseTextButton = forwardRef(function CollapseTextButton(
  {
    children,
    iconStart,
    iconEnd,
    className,
    shape = 'pill',
    ...rest
  },
  ref
) {
  const hasLabel = children != null && children !== '';

  return (
    <ReusableButton
      ref={ref}
      shape={shape}
      iconStart={iconStart}
      iconEnd={iconEnd}
      className={['ctb-btn', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {hasLabel ? children : null}
    </ReusableButton>
  );
});

CollapseTextButton.displayName = 'CollapseTextButton';

export default CollapseTextButton;
